<template>
  <div class="text-metric-options">
    <el-form-item label="指标标题"><el-input :value="settings.title" aria-label="指标标题" maxlength="256" placeholder="例如：接入充电桩" @input="set('metricTitle', $event)" /></el-form-item>
    <el-form-item label="后缀内容"><el-input :value="settings.suffix" aria-label="后缀内容" maxlength="64" placeholder="例如：台、kWh、%" @input="set('metricSuffix', $event)" /></el-form-item>
    <el-form-item label="说明文字"><el-input :value="settings.description" aria-label="说明文字" maxlength="256" placeholder="例如：授权范围内（可留空）" @input="set('metricCaption', $event)" /></el-form-item>
    <el-form-item label="后缀字号"><el-input-number :value="settings.suffixSize" aria-label="后缀字号" :min="1" :max="200" controls-position="right" @input="set('metricSuffixSize', $event)" /></el-form-item>
    <el-form-item label="后缀间距"><el-input-number :value="settings.suffixGap" aria-label="后缀与主内容间距" :min="0" :max="200" controls-position="right" @input="set('metricSuffixGap', $event)" /></el-form-item>
    <el-collapse>
      <el-collapse-item title="标题与说明样式">
        <el-form-item label="标题字号"><el-input-number :value="settings.titleSize" aria-label="指标标题字号" :min="1" :max="200" controls-position="right" @input="set('metricTitleSize', $event)" /></el-form-item>
        <el-form-item label="标题颜色"><avue-input-color :value="settings.titleColor" @input="set('metricTitleColor', $event)" /></el-form-item>
        <el-form-item label="后缀颜色"><avue-input-color :value="settings.suffixColor" @input="set('metricSuffixColor', $event)" /></el-form-item>
        <el-form-item label="说明字号"><el-input-number :value="settings.descriptionSize" aria-label="说明文字字号" :min="1" :max="200" controls-position="right" @input="set('metricCaptionSize', $event)" /></el-form-item>
        <el-form-item label="说明颜色"><avue-input-color :value="settings.descriptionColor" @input="set('metricCaptionColor', $event)" /></el-form-item>
        <el-form-item label="行间距"><el-input-number :value="settings.rowGap" aria-label="指标文本行间距" :min="0" :max="200" controls-position="right" @input="set('metricRowGap', $event)" /></el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { textMetricSettings } from '@/runtime/text-metric'
export default {
  inject: ['main'],
  computed: { settings () { return textMetricSettings(this.main.activeOption) } },
  methods: { set (key, value) { this.$set(this.main.activeOption, key, value) } }
}
</script>
<style scoped>
.el-input-number { width: 100%; }
</style>
